// src/utils/publiekOverzicht.js
// De publieke voorvertoningen per soort (doorloopje, waarom- en hoe-stuk): waar ze op de site staan,
// waar de backend ze geeft en waar ze in de app staan. En het overzicht (/alle-doorloopjes) in
// groepen: de doorloopjes per thema (op titel, die zonder thema als laatste onder "Overig"), daarna
// de waarom- en de hoe-stukken; elke groep met zijn soort en een anker om naartoe te springen. Op de
// pagina staan per groep eerst de uitgelichte, dan die met een afbeelding (vooraan).
// CommonJS, zoals seoText.js: de site en de scripts (prerender, sitemap, llms.txt) gebruiken het allemaal.
// Zonder object-spread: Babel zet daarvoor een ESM-helper in en dan ziet webpack de exports niet.
const SOORTEN = {
  doorloopje: { pad: '/doorloopje', api: '/api/doorloopjes/preview', app: '/doorloopjes', naam: 'Doorloopje', meervoud: 'Doorloopjes' },
  why: { pad: '/waarom', api: '/api/whies/preview', app: '/why', naam: 'Waarom', meervoud: 'Waaroms' },
  how: { pad: '/hoe', api: '/api/hows/preview', app: '/how', naam: 'Hoe', meervoud: 'Hoes' },
};

const voorvertoningPad = (slug, soort = 'doorloopje') => `${SOORTEN[soort].pad}/${slug}`;

function perThema(doorloopjes) {
  const groepen = new Map();
  for (const d of doorloopjes) {
    const naam = (d.theme && d.theme.title) || 'Overig';
    if (!groepen.has(naam)) groepen.set(naam, []);
    groepen.get(naam).push(d);
  }
  return [...groepen.entries()]
    .sort(([a], [b]) => (a === 'Overig') - (b === 'Overig') || a.localeCompare(b, 'nl'))
    .map(([titel, items]) => ({ titel, soort: 'doorloopje', items }));
}

const anker = (titel) =>
  titel.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

function overzichtsGroepen(items) {
  const vanSoort = (soort) => items.filter((d) => d.type === soort);
  return [
    ...perThema(vanSoort('doorloopje')),
    { titel: SOORTEN.why.naam, soort: 'why', items: vanSoort('why') },
    { titel: SOORTEN.how.naam, soort: 'how', items: vanSoort('how') },
  ]
    .filter((groep) => groep.items.length > 0)
    .map((groep) => Object.assign(groep, { anker: anker(groep.titel) }));
}

// Uitgelicht eerst, dan met een afbeelding, verder in de volgorde van de lijst (op titel).
const rang = (d) => (d.featured ? 0 : d.image ? 1 : 2);
const vooraan = (items) => items.slice().sort((a, b) => rang(a) - rang(b));

module.exports = { SOORTEN, voorvertoningPad, overzichtsGroepen, vooraan };
